import React from 'react';
import { useTranslation } from 'react-i18next';
import './LeaveConfirmDialog.css';

interface LeaveConfirmDialogProps {
  onSaveAndLeave: () => void;
  onDiscardAndLeave: () => void;
  onStay: () => void;
}

function LeaveConfirmDialog({ onSaveAndLeave, onDiscardAndLeave, onStay }: LeaveConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <div className="leave-dialog-overlay" onClick={onStay}>
      <div className="leave-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>{t('components.leaveConfirm.title')}</h3>
        <p>{t('components.leaveConfirm.message')}</p>
        <div className="leave-dialog-actions">
          <button className="leave-btn leave-btn-save" onClick={onSaveAndLeave}>
            {t('requests.saveDraft')} &amp; {t('offers.leavePage')}
          </button>
          <button className="leave-btn leave-btn-discard" onClick={onDiscardAndLeave}>
            {t('common.delete')} &amp; {t('offers.leavePage')}
          </button>
          <button className="leave-btn leave-btn-stay" onClick={onStay}>
            {t('offers.stayOnPage')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeaveConfirmDialog;
